import React from 'react'

export default function CardProject({image, title, description, web, github})
{
    return(
       <div className="wrapper-card">
        <div className="thumbnail"> 
        <center>
        <img width="50%" alt="" src={image} />
        </center>
         <div className="caption">
         <h5><b>{title}</b></h5>
          <h6 className="color-text-card">{description}</h6>
              <p>
              See more <a target="_blank" rel="noopener noreferrer" href={web}><i className="fas fa-globe"></i></a> - <a target="_blank" rel="noopener noreferrer" href={github}><i className="fab fa-github text-dark"></i></a>
              </p>
         </div>
        </div>
       </div> 
    )
}